import { Card, Stack, Typography } from '@mui/material'
import React, { memo } from 'react'
import RuleNodeHandle from './RuleNodeHandle'
import PlusBox from './PlusBox'
import { RuleOperators, getColorFromResult } from './ruler_utils'
import DeleteNodeToolbar from './DeleteNodeToolbar'

const ValueOrAddBox = ({ value, hover }) => {
  if (!value) {
    return (
      <PlusBox hover={hover} />
    )
  } else {
    return <Typography color={hover ? 'primary' : 'secondary'}>{value}</Typography>
  }
}

const getOperatorName = (operatorCode) => {
  if (!operatorCode) {
    return null
  }
  return RuleOperators.find((operator) => operator.code === operatorCode)?.name
}

const ConditionNode = ({ data, selected }) => {
  return (
    <>
      <DeleteNodeToolbar handleNodeDelete={data.onNodeDelete} nodeId={data.nodeId} />
      <div>
        <Card sx={{ padding: '0.5rem', border: '0.2rem solid', borderColor: (theme) => selected ? theme.palette.secondary.main : getColorFromResult('transparent', data.testResult) }}>
          <Stack direction='row' alignItems='center' gap={1}>
            <ValueOrAddBox value={data.fact ? data.fact.name : ''} hover={data.hover && data.dragInfo?.type === 'formula' && data.dragInfo?.position?.left < 0.5} />
            {!data.fact || data.fact.type !== 'rule' ? <ValueOrAddBox value={getOperatorName(data.operator)} hover={data.hover && data.dragInfo?.type === 'condition'} /> : null}
            {!data.fact || data.fact.type !== 'rule' ? <ValueOrAddBox value={data.value ? data.value.name : ''} hover={data.hover && data.dragInfo?.type === 'formula' && data.dragInfo?.position?.left >= 0.5} /> : null}
          </Stack>
        </Card>
        <RuleNodeHandle target />
      </div>
    </>
  )
}

export default memo(ConditionNode)
